import React from 'react';
import { Link } from 'react-router-dom';
import { Car, Home, Building2, Shield, Truck, Heart, Plane, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { insuranceProducts } from '../mock';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Car, Home, Building2, Shield, Truck, Heart, Plane, ShieldCheck
};

const InsuranceProducts = () => {
  const { language } = useLanguage();
  const products = insuranceProducts[language];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {language === 'en' 
              ? 'Get under the umbrella — real coverage, real advice, real trust.' 
              : 'Póngase bajo el paraguas — cobertura real, asesoramiento real, confianza real.'}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {language === 'en'
              ? 'We offer a wide range of customized insurance options to safeguard your assets, business, and future:'
              : 'Ofrecemos una amplia gama de opciones de seguro personalizadas para proteger sus activos, negocio y futuro:'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product) => {
            const Icon = iconMap[product.icon];
            const isClickable = product.link;
            const isExternal = isClickable && product.link.startsWith('http');
            const CardWrapper = isClickable ? (isExternal ? 'a' : Link) : 'div';
            const wrapperProps = isClickable ? (
              isExternal ? {
                href: product.link,
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {
                to: product.link
              }
            ) : {};
            
            return (
              <Card
                key={product.id}
                className="group hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2 border-none bg-white"
              >
                <CardWrapper {...wrapperProps} className="block h-full">
                  <CardContent className="p-8 space-y-4 h-full flex flex-col">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl flex items-center justify-center group-hover:from-blue-600 group-hover:to-blue-700 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
                      <Icon className="w-8 h-8 text-blue-700 group-hover:text-white transition-colors" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 group-hover:text-blue-700 transition-colors">
                      {product.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed flex-grow">
                      {product.description.includes('(RTRL006)') ? (
                        <>
                          {product.description.split('(RTRL006)')[0]}
                          <strong className="font-bold">(RTRL006)</strong>
                        </>
                      ) : (
                        product.description
                      )}
                    </p>
                    <button className="text-blue-700 font-semibold group-hover:gap-2 inline-flex items-center gap-1 transition-all">
                      {language === 'en' ? 'Learn More' : 'Más Información'}
                      <span className="group-hover:translate-x-1 transition-transform">→</span>
                    </button>
                  </CardContent>
                </CardWrapper>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default InsuranceProducts;